import validate from "/opt/simploshop/node_modules/.pnpm/nuxt@https+++pkg.pr.new+nuxt@32899_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+no_376380550bbae3aa60ac1d44b23ca449/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/simploshop/shared/core-theme/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/simploshop/node_modules/.pnpm/nuxt@https+++pkg.pr.new+nuxt@32899_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+no_376380550bbae3aa60ac1d44b23ca449/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  cart: () => import("/opt/simploshop/shared/core-theme/app/middleware/cart.ts")
}